module.exports = __webpack_public_path__ + "Flama-Black.woff2?28abbdbd9073722a4677dba5161e44b1";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-Black.woff2
// module id = 923
// module chunks = 0